export default {
  review: {
    title: 'Bewertungen',
    seeAll: 'Alle Bewertungen lesen',
    heading: {
      title: 'Wir freuen uns über Deine Bewertung.',
      description:
        'Dein Feedback hilft dem Kursleiter sehr. Auf gokonfetti.com wird nur Dein Vorname veröffentlicht.',
    },
    rating: {
      title: 'Gibst Du dem Kurs 5 Sterne?',
    },
    review: {
      title: 'Schreibe ein paar Sätze über den Kurs.',
      placeholder:
        'z.B.: Für wen würdest Du den Kurs empfehlen? Was hat Dir am besten gefallen?',
    },
    legalCopy:
      'Mit dem Absenden Deiner Bewertung erklärst Du Dich mit unseren {termsAndConditions} einverstanden.',
    termsAndConditions: 'AGB',
    notification: {
      success: {
        title: 'Vielen Dank für Deine Bewertung',
        description:
          'Als kleines Dankeschön für Dein Feedback erhältst du 15 € Rabatt mit dem Code KONBACK10. Mindestbestellwert 50 €.',
      },
      error: {
        title: 'Es ist ein Fehler aufgetreten',
        description:
          'Wenn Du diesen Kurs bereits bewertet hast, kannst Du sie nicht erneut bewerten.',
      },
    },
    form: {
      title: 'Wie war Dein/e {category}',
      starsLabel: 'Bewerte Dein Erlebnis',
      starsError: 'Bitte geben Sie Ihre Bewertung an',
      textareaLabel: 'Teile Deine Erfahrungen',
      textareaPlaceholder:
        'Wie waren die Verpackung, der Versand und das Erlebnis?',
      textareaText: 'Titel Deiner Bewertung: "{n}..."',
      textareaError: 'Bitte geben Sie den Text Ihres Feedbacks ein',
      uploadLabel: 'Hier kannst Du Fotos oder Videos hinzufügen',
      uploadText: 'Du kannst maximal {max} Dateien hinzufügen',
      submitButton: 'Bewertung einreichen',
      successTitle: 'Danke für Deine Bewertung!',
      successText: 'Hier ist ein Rabattcode für Dein nächstes Erlebnis:',
      copyCode: 'Rabattcode kopieren',
      copyCodeSuccess: 'Kopiert',
      backButton: 'Zurück zu konfetti',

      course: {
        title: 'Wie war Dein Kurs?',
        starsLabel: 'Bewerte den Kurs',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren Kursleiter, die Materialien und Dein Erlebnis? Was hast Du gelernt?',
      },

      tour: {
        title: 'Wie war die Tour?',
        starsLabel: 'Bewerte Deine Tour',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren die Tourroute, der Guide und Dein Erlebnis insgesamt?',
      },

      experience: {
        title: 'Wie war Dein Erlebnis?',
        starsLabel: 'Bewerte Dein Erlebnis',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren die Aktivität, die Location und das Personal?',
      },

      kit: {
        title: 'Wie gefällt Dir die DIY-Box?',
        starsLabel: 'Bewerte Deine Box',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie sind Inhalt, Verpackung, Versand und das Erlebnis mit der Box?',
      },
    },
  },
}
